import moment from 'moment'
import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { Credit } from '../../types'
import ActionTypes from './actionTypes'
import { ArrayUtils, ObjectUtils } from '../../utils'

type CreditCreateRequest = {
    type: typeof ActionTypes.CREDIT_CREATE_REQUEST;
    payload: never;
}

type CreditCreateFailure = {
    type: typeof ActionTypes.CREDIT_CREATE_FAILURE;
    payload: Error;
}

type CreditCreateSuccess = {
    type: typeof ActionTypes.CREDIT_CREATE_SUCCESS;
    payload: Credit;
}

export type CreditCreation = Omit<Credit, 'id'>

const CreateCreditFields = [
    'type',
    'start_date',
    'end_date',
    'skus',
] as const

/**
 * Create one credit
 */
function createCredit(credit: CreditCreation) {
    const body = ObjectUtils.copy(credit, CreateCreditFields, {
        start_date: (v: Date) => moment(v).format('YYYY-MM-DD'),
        end_date: (v: Date) => moment(v).format('YYYY-MM-DD'),
        skus: ArrayUtils.cleanStringArray,
    })

    return createAction<RootState, Credit, never>({
        endpoint: `${HUBBLE_API_TOKEN}/credits`,
        method: 'POST',
        body: JSON.stringify(body),
        types: [
            ActionTypes.CREDIT_CREATE_REQUEST,
            ActionTypes.CREDIT_CREATE_SUCCESS,
            ActionTypes.CREDIT_CREATE_FAILURE,
        ],
    })
}

export type CreditCreateAction = CreditCreateRequest
    | CreditCreateFailure
    | CreditCreateSuccess

export default createCredit
